<script>
    // Status handeling of meta data https://poststatus.com/state-handling-custom-metadata-wordpress/
    import axios from 'axios'
    import 'regenerator-runtime/runtime'

    import { onMount } from 'svelte'
    import ControlErrorList from './ControlErrorList.svelte';
    import Loading from './Loading.svelte';

    const { getUrlParameter } = require('../api/get-url-parameter')

    export let configuration

    let invalidities = []
    let hasAttempted = false
    let isSubmitting = false
    let showPassword = false
    let type = "password";

    let controls = [...configuration.initialState.controls]
    let submitButton

    let email = '';
    let password = '';


    onMount( () => {
      submitButton?.focus()
    } )

    const trySubmit = async (e) => {
        e.preventDefault()

        if(!hasAttempted){
            hasAttempted = true
        }
        doSubmit()

    }

    const doSubmit = async () => {

        if(!isSubmitting){
            isSubmitting = true

            const formData = new FormData()
            const info = [{id:'user_email', value:email}, {id:'user_password', value:password}]

            formData.append('controls', JSON.stringify(info))
            // console.log("formData",formData)
            let result
            const redirectTo = getUrlParameter('redirect_to');
            // console.log("!!!!!! redirectTo",redirectTo);
            await axios
                .post("/wp-json/customweb/v1/user-login", formData, {
                    headers: {
                        'X-WP-Nonce': data.rest.nonce,
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    // console.log(response.data)
                    isSubmitting = false
                    result = response.data;
                    invalidities = []
                    if(result.hasOwnProperty('success')){
                        // console.log('success')
                        if(redirectTo && redirectTo.length > 0){
                            window.location.replace(window.location.origin+redirectTo)
                        } else {
                            window.location.replace(window.location.origin+'/dashboard')
                        }
                    } else if (result.hasOwnProperty('errors')){
                        if(result['errors'].hasOwnProperty('invalid_email')){
                            invalidities.push(
                                {
                                    'controlId':'user_email',
                                    'text':'The email is not registered on this site. Please contact your Regional Manager.',
                                }
                            )
                        }
                        if(result['errors'].hasOwnProperty('invalid_username')){
                            invalidities.push(
                                {
                                    'controlId':'user_email',
                                    'text':'The email is not registered on this site. Please contact your Regional Manager.',
                                }
                            )
                        }
                        if(result['errors'].hasOwnProperty('empty_username')){
                            invalidities.push(
                                {
                                    'controlId':'user_email',
                                    'text':'Empty email.',
                                }
                            )
                        }
                        if(result['errors'].hasOwnProperty('empty_password')){
                            invalidities.push(
                                {
                                    'controlId':'user_password',
                                    'text':'Empty password.',
                                }
                            )
                        }
                        if(result['errors'].hasOwnProperty('incorrect_password')){
                            invalidities.push(
                                {
                                    'controlId':'user_password',
                                    'text':'The password you entered is incorrect.',
                                }
                            )
                        }
                    }
                });
        }

    };


    const hasError = (control, invalidities) => {
        // console.log("hasError",control, invalidities)
        if (invalidities.length > 0) {
            return invalidities.find((invalid) => {
                return invalid.controlId === control.id;
            })
                ? "error"
                : "no-error";
        } else {
            return "no-error";
        }
    };

    const getControl = (controlId) => {
      let control = null
      if(controls){
        controls.forEach( controlState => {
          if(controlState.id === controlId){
              control = controlState
          }
        })
      }
      return control
  }

    $: disabledButton = isSubmitting

</script>

<form on:submit|preventDefault={trySubmit} class="gravity-form-wrap py-24">
    <div class="gf_browser_chrome gform_wrapper gravity-theme">
        <div class="gform_body gform-body">
            <div class="gform_fields top_label form_sublabel_below description_below">

                            <div id="field-email-container" class="gfield gfield--width-full field_description_above gfield_visibility_visible">
                                <label class="gfield_label" for="field-email-control">Email Address</label>
                                <div class="ginput_container ginput_container_text">
                                    <input
                                      id="field-email-control"
                                      type="text"
                                      bind:value={email}
                                      required
                                      autocomplete="username"
                                      class="large {hasError(getControl('user_email'), invalidities)}"
                                      aria-invalid="false"
                                      aria-describedby="field-email-summary"
                                    />
                                </div>
                                <ControlErrorList control={getControl('user_email')} {invalidities} />
                            </div>
                            <div id="field-password-container" class="gfield gfield--width-full field_description_above gfield_visibility_visible">
                                <label class="gfield_label" for="field-password-control">Password</label>
                                <div class="ginput_container ginput_container_text p-relative">
                                    <input
                                        id="field-password-control"
                                        bind:value={password}
                                        required
                                        autocomplete="current-password"
                                        {...{ type }}
                                        class="large {hasError(getControl('user_password'), invalidities)}"
                                        aria-invalid="false"
                                        aria-describedby="field-password-summary"
                                    >
                                    <button
                                        type="button"
                                        class="show-password w-24 h-24 cursor-pointer d-block p-absolute right-8 top-8 z-10 text-blue hover:text-orange"
                                        on:click={() => {
                                            showPassword = !showPassword;
                                            if(showPassword) {
                                                type = 'text';
                                            } else {
                                                type = 'password';
                                            }
                                        }}
                                    >
                                    {#if showPassword}
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" fill="currentColor"/></svg>
                                    {:else}
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z" fill="currentColor"/></svg>
                                    {/if}
                                    </button>
                                </div>
                                <ControlErrorList control={getControl('user_password')} {invalidities} />
                            </div>
                </div>
            </div> <!-- end gform_body -->
            <div class="gform_footer top_label">
                <button
                    bind:this={submitButton}
                    type="submit"
                    disabled={disabledButton}
                    class="{disabledButton
                        ? 'disabled'
                        : ''} btn btn-orange mt-24"
                    on:click={trySubmit}
                >
                    <span class=""
                        >Log In</span
                    >
                </button>
            </div>

    </div>
</form>
<Loading hidden={!isSubmitting} />
